module.exports = __webpack_public_path__ + "img/wire-2.2cf79754.jpg";